export const SESSION_TOKEN = 'session-token';
